import { Directive } from '@angular/core';
import { TableListGridProviderDirective } from '@app/components/table-list-grid/directives/table-list-grid-provider.directive';
import { ListViewProviderDirective, ViewProviderDirective } from '@ntap/core';
import { ParentListViewProvider } from './parent-list-view.provider';

@Directive({
  selector: '[appPretragaKatalogaProvider]',
  providers: [
    {
      provide: ListViewProviderDirective,
      useExisting: PretragaKatalogaProviderDirective
    },
    {
      provide: ViewProviderDirective,
      useExisting: PretragaKatalogaProviderDirective
    },
    {
      provide: ParentListViewProvider,
      useExisting: PretragaKatalogaProviderDirective
    },
    {
      provide: TableListGridProviderDirective,
      useExisting: PretragaKatalogaProviderDirective
    }
  ]
})
export class PretragaKatalogaProviderDirective extends TableListGridProviderDirective {
  override addItem(item: object) {
    // FIX -- ako korisnik odustane privremene ne guramo u listu
    if (this.isActiveObject(item)) {
      super.addItem(item);
    }
  }

  private isActiveObject(item: object) {
    return (item as any)['en~jedinica_gradiva~status'] === 'A';
  }
}
